import {
  clsx_default
} from "../../../../chunk-QJVDQ4DQ.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ContentChips/ProductMentionChip.tsx
import { useComponentsTranslation } from "../../../../i18n/useComponentsTranslation.mjs";
import { shopifyImageSource } from "../../../../utils/shopifyImageSource.mjs";
import { Text } from "../../../primitive/index.mjs";
import { ImageFrame } from "../../../primitive/ImageFrame/ImageFrame.mjs";
import { MENTION_CHIP_IMAGE_PX } from "../shared/mentionChipImage.mjs";
import { resolveProductUrl } from "./productMentions.mjs";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function urlWithoutQuery(url) {
  try {
    const u = new URL(url);
    const path = u.pathname.replace(/\/$/, "") || "/";
    return `${u.origin}${path}`;
  } catch {
    return url;
  }
}
function isProductCurrentPage(productUrl) {
  if (typeof window === "undefined" || !productUrl) return false;
  const current = urlWithoutQuery(window.location.href);
  const product = urlWithoutQuery(productUrl);
  return current === product;
}
function ProductMentionChip({
  product,
  size = "message",
  className = "",
  style,
  storeDomain
}) {
  const { t } = useComponentsTranslation();
  const fullProductUrl = resolveProductUrl(product.url, storeDomain);
  const isCurrentPage = fullProductUrl ? isProductCurrentPage(fullProductUrl) : false;
  const isClickable = !!fullProductUrl && !isCurrentPage;
  const displayTitle = product.title.length > 20 ? `${product.title.slice(0, 20)}\u2026` : product.title;
  const chipTitle = isCurrentPage ? t("productMention.currentProductChip") : product.title;
  const content = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      ImageFrame,
      {
        ...product.imageUrl ? shopifyImageSource(product.imageUrl, MENTION_CHIP_IMAGE_PX) : void 0,
        alt: "",
        fallback: "bag-filled",
        className: product.imageUrl ? "product-mention-chip-image" : "product-mention-chip-icon"
      }
    ),
    /* @__PURE__ */ jsx(Text, { variant: size === "message" ? "body-xs" : "body-sm", as: "span", className: "product-mention-chip-title", title: chipTitle, dir: "auto", children: displayTitle })
  ] });
  const chipClassName = clsx_default(
    "product-mention-chip",
    `size-${size}`,
    isClickable && "clickable",
    isCurrentPage && "current-page",
    className
  );
  return isClickable ? /* @__PURE__ */ jsx(
    "a",
    {
      href: fullProductUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: chipClassName,
      style,
      contentEditable: false,
      "data-product-id": product.id,
      title: chipTitle,
      onClick: (e) => e.stopPropagation(),
      children: content
    }
  ) : /* @__PURE__ */ jsx(
    "span",
    {
      className: chipClassName,
      style,
      contentEditable: false,
      "data-product-id": product.id,
      title: chipTitle,
      children: content
    }
  );
}
export {
  ProductMentionChip
};
//# sourceMappingURL=ProductMentionChip.mjs.map